import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updatesubAdmin } from "../features/slices/subAdmin";
import { toastService } from "../utils/toastify";
const initialState = {
  id: "",
  name: "",
  email: "",
  phoneNumber: "",
  designation: "",
  permission: [
    // {
    //   name: "Dashboard",
    //   read: false,
    //   fullAccess: false,
    // },
    {
      name: "Student",
      read: false,
      fullAccess: false,
    },
    {
      name: "Feed",
      read: false,
      fullAccess: false,
    },
    {
      name: "Category",
      read: false,
      fullAccess: false,
    },
    {
      name: "Courses",
      read: false,
      fullAccess: false,
    },
    {
      name: "Podcasts",
      read: false,
      fullAccess: false,
    },
    {
      name: "Challenges&Bounty",
      read: false,
      fullAccess: false,
    },
    {
      name: "Livestream",
      read: false,
      fullAccess: false,
    },
    {
      name: "Payment",
      read: false,
      fullAccess: false,
    },
    {
      name: "Sub-Admin",
      read: false,
      fullAccess: false,
    },
    {
      name: "Notification",
      read: false,
      fullAccess: false,
    },
    {
      name: "Static-Content",
      read: false,
      fullAccess: false,
    },
  ],
};
const EditSubAdmin = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { name, email, phoneNumber, designation, permission, id } = iState;
  const { state } = useLocation();

  useEffect(() => {
    setUpdateState({
      id: state?._id,
      name: state?.name,
      email: state?.email,
      phoneNumber: state?.phoneNumber,
      designation: state?.designation,
      permission: [...state?.permission],
    });
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCheck = (e, fieldName) => {
    const { name, checked } = e?.target;
    setUpdateState((prev) => ({
      ...prev,
      permission: prev.permission.map((item) =>
        item.name === fieldName
          ? { ...item, [name]: checked } // Update the field (either 'read' or 'fullAccess')
          : item
      ),
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateState({ ...iState, [name]: value });
  };
  const handleUpdateSubAdmin = () => {
    dispatch(updatesubAdmin(iState)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Sub Admin updated successfully");
        navigate("/subadmin");
      } else {
        toastService.error("Sub Admin updated failed");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit Sub-Admin</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Name"
                name="name"
                value={name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Phone Number"
                name="phoneNumber"
                value={phoneNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email ID</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email ID"
                name="email"
                value={email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <select
                className="form-control"
                name="designation"
                value={designation}
                onChange={handleChange}
              >
                <option selected="">select</option>
                <option value={"manager"}>manager</option>
              </select>
            </div>
          </div>
          <div className="TitleBox Border mt-4">
            <h4 className="Title">Sub-Admin Rights Access</h4>
          </div>
          <div className="TableList BorderTop GreyCheckBox">
            <table className="table">
              {/* <thead>
                      <tr>
                          <th>Module</th>
                          <th colspan="2">Access</th> 
                          <th>
                      </th></tr>
                  </thead> */}
              <tbody>
                {permission.map((res) => {
                  return (
                    <tr>
                      <td style={{ borderTop: "none" }}>
                        <strong>{res?.name}</strong>
                      </td>
                      <td style={{ borderTop: "none" }}>
                        <label className="CheckBox">
                          {" "}
                          Read
                          <input
                            type="checkbox"
                            name="read"
                            checked={res?.read}
                            onChange={(e) => handleCheck(e, res?.name)}
                          />
                          <span className="checkmark" />
                        </label>
                      </td>
                      <td style={{ borderTop: "none" }}>
                        <label className="CheckBox">
                          {" "}
                          Full Access
                          <input
                            type="checkbox"
                            name="fullAccess"
                            checked={res?.fullAccess}
                            onChange={(e) => handleCheck(e, res?.name)}
                          />
                          <span className="checkmark" />
                        </label>
                      </td>
                      <td style={{ borderTop: "none" }} />
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button className="Button" onClick={handleUpdateSubAdmin}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditSubAdmin;
